<div (click)="close()" class="d-flex flex-column justify-content-center align-items-center w-90 h-90">
   <button class="close-btn" (click)="close()" ><span class="fa fa-x"></span></button>
   <div   class="d-flex flex-column justify-content-center align-items-center">
        <div class="mb-3">
            @if(cropInformation){
                <div style="width: 20rem; aspect-ratio: 1/1;">
                    <app-cropped-image [imgSrc]="imageSrc"  class="w-100"
                    [cropInformation]="cropInformation" ></app-cropped-image>
               </div>
              

            }@else{
                <img loading="lazy" (click)="$event.stopPropagation()" [src]="imageSrc"  style="max-height: 50vh; max-width: 50vw;"/>

            }
         
           
        </div>
        
        <div style="
        font-style: italic; word-wrap: break-word;
        background-color: var(--white);
        font-size: 1rem; color: var(--primary); 
        text-align: start; font-weight: bold;" *ngIf="descr" class="p-5 w-100">
            ❝{{descr}}❞
        </div> 
   </div>

</div>